// extracted by mini-css-extract-plugin
export default {"card":"basic-grid_card__bZN+a","basicGrid":"basic-grid_basicGrid__u+RIC"};